module.exports = __webpack_public_path__ + "img/ellipse.49200d36.svg";